module.exports = __webpack_public_path__ + "img/Septris-sprite-start - with text.2844c4a4.png";